// extracted by mini-css-extract-plugin
export default {"statements":"style_statements__Kc9DZ","cardsContainer":"style_cardsContainer__43pjn","divider":"style_divider__-neI9"};